import { apiTransport as router } from './transport';
import { getContext } from './core';
import type { QueryFilters } from './transport';

export type GovernanceLogRecord = {
  id: string;
  type: string;
  title: string;
  description: string;
  eventTimestamp: string;
  entityId?: string;
  entityType?: string;
  url?: string;
  userId?: string;
  status?: string;
  metadata?: Record<string, unknown>;
  operatingOrganizationId?: string;
};

export type GovernanceLogCreatePayload = {
  type: string;
  title: string;
  description: string;
  entityId?: string;
  entityType?: string;
  url?: string;
  userId?: string;
  status?: string;
  metadata?: Record<string, unknown>;
  operatingOrganizationId?: string;
};

export const governanceApi = {
  logs: {
    list: async (filters?: { types?: string; search?: string }) => {
      const context = getContext();
      const q: QueryFilters | undefined =
        filters?.types != null || filters?.search != null
          ? {
              ...(filters.types != null && filters.types !== '' ? { types: filters.types } : {}),
              ...(filters.search != null && filters.search !== '' ? { search: filters.search } : {}),
            }
          : undefined;
      return router.get<GovernanceLogRecord[]>('/governance/logs', context, q);
    },
    create: async (payload: GovernanceLogCreatePayload) => {
      const context = getContext();
      return router.post<GovernanceLogRecord>('/governance/logs', payload, context);
    },
  },
};

